import React, { useState, useEffect } from 'react';
import './MarkoSaramandic.css';

const MarkoSaramandic = () => {
  // For countdown timer
  const [timeLeft, setTimeLeft] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0
  });

  // Set launch date - 30 days from now
  const calculateTimeLeft = () => {
    const launchDate = new Date();
    launchDate.setDate(launchDate.getDate() + 30);
    
    const difference = launchDate - new Date();
    
    if (difference > 0) {
      setTimeLeft({
        days: Math.floor(difference / (1000 * 60 * 60 * 24)),
        hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
        minutes: Math.floor((difference / 1000 / 60) % 60),
        seconds: Math.floor((difference / 1000) % 60)
      });
    }
  };

  // For fade-in effect
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Set document title
    document.title = "Marko Saramandić | Software Engineer";
    
    setIsVisible(true);
    
    const timer = setInterval(() => {
      calculateTimeLeft();
    }, 1000);

    // Initialize timer
    calculateTimeLeft();

    return () => clearInterval(timer);
  }, []);

  return (
    <div className="luxury-container">
      <div className="luxury-background"></div>
      
      <div className={`luxury-content ${isVisible ? 'visible' : ''}`}>
        <div className="luxury-monogram">
          <div className="monogram-inner">
            <span>M</span>
            <span>S</span>
          </div>
        </div>
        
        <div className="luxury-header">
          <h1>Marko Saramandić</h1>
          <div className="luxury-established">Software Engineer</div>
        </div>
        
        <div className="luxury-divider">
          <div className="divider-line"></div>
          <div className="divider-emblem"></div>
          <div className="divider-line"></div>
        </div>
        
        <div className="luxury-tagline">Crafting elegant solutions to complex problems</div>
        
        <div className="luxury-announcement">Portfolio launching in</div>
        
        <div className="luxury-countdown">
          <div className="countdown-block">
            <div className="countdown-number">{timeLeft.days}</div>
            <div className="countdown-label">Days</div>
          </div>
          <div className="countdown-block">
            <div className="countdown-number">{timeLeft.hours}</div>
            <div className="countdown-label">Hours</div>
          </div>
          <div className="countdown-block">
            <div className="countdown-number">{timeLeft.minutes}</div>
            <div className="countdown-label">Minutes</div>
          </div>
          <div className="countdown-block">
            <div className="countdown-number">{timeLeft.seconds}</div>
            <div className="countdown-label">Seconds</div>
          </div>
        </div>
        
        <div className="luxury-heritage">
          <div className="heritage-area">
            <div className="heritage-title">Full-Stack Development</div>
            <div className="heritage-line"></div>
          </div>
          <div className="heritage-area">
            <div className="heritage-title">Cloud Architecture</div>
            <div className="heritage-line"></div>
          </div>
          <div className="heritage-area">
            <div className="heritage-title">Mobile Applications</div>
            <div className="heritage-line"></div>
          </div>
          <div className="heritage-area">
            <div className="heritage-title">UI/UX Design</div>
            <div className="heritage-line"></div>
          </div>
          <div className="heritage-area">
            <div className="heritage-title">AI Integration</div>
            <div className="heritage-line"></div>
          </div>
        </div>
        
        <div className="luxury-social">
          <a href="#" className="social-link" target="_blank" rel="noopener noreferrer">GitHub</a>
          <span className="social-separator">•</span>
          <a href="#" className="social-link" target="_blank" rel="noopener noreferrer">LinkedIn</a>
          <span className="social-separator">•</span>
          <a href="#" className="social-link" target="_blank" rel="noopener noreferrer">Twitter</a>
        </div>
        
        <div className="luxury-contact">
          <a href="mailto:marko@saramandic.com">marko@saramandic.com</a>
        </div>
        
        <div className="luxury-footer">
          <div className="footer-line"></div>
          <div className="footer-text">&copy; {new Date().getFullYear()} Marko Saramandić. All Rights Reserved.</div>
        </div>
      </div>
    </div>
  );
};

export default MarkoSaramandic;